(function () {
  "use strict";

  var banner = document.querySelector(".promo-banner");
  if (!banner) return;

  var promoStart = banner.dataset.promoStart
    ? new Date(banner.dataset.promoStart)
    : null;
  var promoEnd = banner.dataset.promoEnd
    ? new Date(banner.dataset.promoEnd)
    : null;

  if (promoStart && isNaN(promoStart.getTime())) promoStart = null;
  if (promoEnd && isNaN(promoEnd.getTime())) promoEnd = null;

  // ── Schedule ─────────────────────────────────────────────────────────────

  function isActive() {
    var now = new Date();
    if (promoStart && now < promoStart) return false;
    if (promoEnd && now > promoEnd) return false;
    return true;
  }

  function applyVisibility() {
    banner.style.display = isActive() ? "flex" : "none";
  }

  // ── Countdown ────────────────────────────────────────────────────────────

  var countdownEl = banner.querySelector(".promo-banner__countdown");
  var countdownInterval = null;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function updateCountdown() {
    if (!countdownEl || !promoEnd) return;

    var diff = promoEnd - new Date();

    if (diff <= 0) {
      banner.style.display = "none";
      clearInterval(countdownInterval);
      countdownEl.textContent = "";
      return;
    }

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    var text =
      days +
      "d " +
      pad(hours) +
      "h " +
      pad(minutes) +
      "m " +
      pad(seconds) +
      "s";
    countdownEl.textContent =
      window.innerWidth < 750 ? text : " | Termina en: " + text;
  }

  // ── Copy to clipboard ─────────────────────────────────────────────────────

  function mostrarCodigoCopiado() {
    var originalHTML = banner.innerHTML;

    // Clear any running interval before swapping HTML
    clearInterval(countdownInterval);
    countdownInterval = null;

    var copied = document.createElement("span");
    copied.style.fontWeight = "bold";
    copied.textContent = banner.dataset.copiedText || "¡Código copiado!";
    banner.innerHTML = "";
    banner.appendChild(copied);

    setTimeout(function () {
      banner.innerHTML = originalHTML;
      // Re-query countdownEl since the DOM was replaced
      countdownEl = banner.querySelector(".promo-banner__countdown");
      updateCountdown();
      countdownInterval = setInterval(updateCountdown, 1000);
    }, 3000);
  }

  function fallbackCopy(text, onSuccess) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.cssText = "position:fixed;top:-999px;left:-999px;opacity:0;";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try {
      document.execCommand("copy");
      onSuccess();
    } catch (err) {
      console.warn("[banner-countdown] Clipboard copy failed:", err);
    }
    document.body.removeChild(ta);
  }

  function handleCopy() {
    var code = this.dataset.code;
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(mostrarCodigoCopiado)
        .catch(function () {
          fallbackCopy(code, mostrarCodigoCopiado);
        });
    } else {
      fallbackCopy(code, mostrarCodigoCopiado);
    }
  }

  // Single delegated listener on the banner root: it survives the innerHTML
  // swap in mostrarCodigoCopiado, so no re-binding is needed. Native <button>
  // elements fire click on Enter/Space, so no keydown handler is required.
  banner.addEventListener("click", function (e) {
    var btn = e.target.closest(".promo-banner__code");
    if (btn) handleCopy.call(btn);
  });

  // ── Init ─────────────────────────────────────────────────────────────────

  applyVisibility();

  if (isActive()) {
    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  var visibilityIntervalId = setInterval(applyVisibility, 60 * 1000);
  var visibilityObserver = new MutationObserver(function () {
    if (!document.contains(banner)) {
      clearInterval(visibilityIntervalId);
      visibilityObserver.disconnect();
    }
  });
  visibilityObserver.observe(document.body, { childList: true, subtree: true });
})();
